// extracted by mini-css-extract-plugin
export default {"btn":"MainButton_btn__ZY8Bv"};